import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { IEpisodesDetail, ISupportLanguage } from 'utils/types/storyTypes';
import { storyApi } from 'apis/story/storyApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import { useAppDispatch } from 'hooks/redux';
import { setEditName, setStoryName } from 'store/slices/breadcumbSlice';
import EpisodeWrapper from './EpisodeWrapper';
import { useCookies } from 'react-cookie';

/**
 * * 오토메 - 작품 정보 수정
 */

const EpisodeEditPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const [cookies] = useCookies();

  const { projectId, episodeId } = useParams();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [data, setData] = useState<IEpisodesDetail | null>(null);
  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);

  const fetchDetailData = async () => {
    try {
      const storyDetailData = await storyApi.storyDetail(projectId);
      const dataRes = await storyApi.episodeDetail(projectId);
      const langRes = await storyApi.supportLang();
      const detailEpisode = dataRes.episodes.find(
        (e) => e.episode_id === Number(episodeId),
      );
      setData(detailEpisode);
      setSupportLangList(langRes);
      dispatch(setEditName(detailEpisode.title));

      const episodeName = storyDetailData?.project?.projectDetails?.find(
        (e) => e.lang === cookies.lang,
      );
      dispatch(
        setStoryName(episodeName ? episodeName.title : storyDetailData.title),
      );
    } catch (err) {
      console.log('fecth data error:', err);
    }
  };

  useEffect(() => {
    fetchDetailData();
  }, []);

  return (
    <>
      <DefaultLayout>
        <Wrapper>
          <EpisodeWrapper
            data={data}
            supportLangList={supportLangList}
            setData={setData}
          />
        </Wrapper>
      </DefaultLayout>
    </>
  );
};

export default EpisodeEditPage;

const Wrapper = styled.div`
  & > * + * {
    margin-top: 8rem;
  }
`;
